import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "../../assets/css/modal.css";
import "./Menu.css";
import "../../assets/css/modal.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { checkEmail } from "../../actions/userActions";

const MenuModal = ({ show, closeModal }) => {

  const [newUserName, setNewUserName] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.headers) {
      var username = JSON.parse(window.localStorage.getItem("headers"));

      dispatch(checkEmail(username.data.user.email, true));
      var newname = username.data.user.fname + " " + (username.data.user.lname !== null ? username.data.user.lname : '');
      setNewUserName(newname);
    }
  }, [localStorage.headers]);

  return (
    <Modal
      show={show}
      onHide={closeModal}
      className="rounded-lg "
      dialogClassName="modal-md menu res-modal"
      centered
    >
      <Modal.Header className="border-bottom-0">
        <button
          type="button"
          className="close"
          onClick={() => {
            localStorage.removeItem("popup");
            closeModal();
          }}
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="head">
          {/* <figure>
            <img src={menuLogo} alt="" />
          </figure> */}
          <h1 style={{ color: "black" }}> Welcome back, </h1>
          <h3>
            <span>{newUserName}</span>
          </h3>
          <p>Thank you for choosing to dine with us!</p>
        </div>

        <div className="foot">
          <button
            className="btn lg primary"
            onClick={() => {
              localStorage.removeItem("popup");
              closeModal();
            }}
          >
            Let's eat!
          </button>
          <p className="copyright">Powered by Warely</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

MenuModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

// export default MenuModal;

const mapStateToProps = (state) => ({
});
export default withTranslation()(
  connect(mapStateToProps, { checkEmail })(MenuModal)
);

